import type { ApiModuleEndpoints } from '../types'

export const authApiEndpoints = {
  login: {
    method: 'POST',
    path: '/auth/login',
  },
  refreshToken: {
    method: 'POST',
    path: '/auth/refresh',
  },
  logout: {
    method: 'POST',
    path: '/auth/logout',
    requiresAuth: true,
  },
  forgotPassword: {
    method: 'POST',
    path: '/auth/forgot-password',
  },
  changePassword: {
    method: 'POST',
    path: '/auth/change-password',
    requiresAuth: true,
  },
  me: {
    method: 'GET',
    path: '/auth/me',
    requiresAuth: true,
  },
  updateProfile: {
    method: 'PATCH',
    path: '/auth/me',
    requiresAuth: true,
  },
  avatarPresign: {
    method: 'POST',
    path: '/auth/me/avatar/presign',
    requiresAuth: true,
  },
  avatarConfirm: {
    method: 'POST',
    path: '/auth/me/avatar/confirm',
    requiresAuth: true,
  },
  avatarDelete: {
    method: 'DELETE',
    path: '/auth/me/avatar',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
